var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8228_23775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0003 50.6667H61.3336V56H2.66699V50.6667H8.00032V10.6667C8.00032 9.95942 8.28128 9.28115 8.78137 8.78105C9.28147 8.28095 9.95975 8 10.667 8H37.3337C38.0409 8 38.7192 8.28095 39.2193 8.78105C39.7194 9.28115 40.0003 9.95942 40.0003 10.6667V50.6667H50.667V29.3333H45.3337V24H53.3337C54.0409 24 54.7192 24.281 55.2193 24.781C55.7194 25.2811 56.0003 25.9594 56.0003 26.6667V50.6667ZM13.3337 13.3333V50.6667H34.667V13.3333H13.3337ZM18.667 29.3333H29.3337V34.6667H18.667V29.3333ZM18.667 18.6667H29.3337V24H18.667V18.6667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8228_23775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/buildingIcon.35973f94805c79b6032839848c258ee3.svg";
export { ForwardRef as ReactComponent };